import { enumRequired, labeled } from '../../util/joi';
import { certificatesOfTitle } from '../global/CertificateOfTitle.enum';
import { typesOfCertificateOfTitle } from '../global/TypeOfCertificateOfTitle.enum';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    title: enumRequired(Joi, certificatesOfTitle, labeled(label, 'Title')),
    titleType: enumRequired(Joi, typesOfCertificateOfTitle, labeled(label, 'Title type'))
  });

export default {
  schema
};
